/**
 * ╔═══════════════╗
 * ║ !!IMPORTANT!! ║
 * ╚═══════════════╝
 * Please do not use statsig feature gating in this file.
 * Read https://hello.atlassian.net/wiki/spaces/JIE/pages/2858513117/Blockers+for+Statsig+in+the+issue-view
 * for why and to follow the fix.
 */
import { getContentPanelsQuery } from '@jira/issue__issue-view-contents-panel-query/src/getContentPanelsQuery.tsx';
import {
	getEcosystemQuery,
	getLegacyRightWebPanelsQuery,
} from '@jira/issue__issue-view-ecosystem-query/src/getEcosystemQuery.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const ISSUE_VIEW_INTERACTIVE_QUERY = 'issueViewInteractiveQuery';

// JIV-19906: retrieve query string from URL -- only expected to be used by client side code
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const getURLFromWindow = () => new URL(window.location.href);

export const viewIssueQuery = (_: URL = getURLFromWindow(), includeForgeQuery = true): string => `
    viewIssue(issueKey: $issueKey) {
        ${fg('remove-issueviewinteractivequery-m4') ? '' : getEcosystemQuery(includeForgeQuery)}
        ${getContentPanelsQuery()}
	    ${!fg('remove-issueviewinteractivequery-m4') ? getLegacyRightWebPanelsQuery() : ''}
    }
`;

// Need viewIssue for prefetch jira/src/packages/issue/issue-view-app-provider/src/prefetched-data-consumption/index.tsx
const EMPTY_QUERY = `query ${ISSUE_VIEW_INTERACTIVE_QUERY}($issueKey: String!) {
	viewIssue(issueKey: $issueKey) {
		__typename
	}
}`;

/**
 * @deprecated DO NOT USE ANYMORE
 * See here for details: https://hello.atlassian.net/wiki/spaces/JFP/pages/6034403445/Investigate+Optimise+issueViewInteractiveQuery
 */
export const buildIssueQuery = (url?: URL): string =>
	fg('remove-issueviewinteractivequery-m4') // For now just making it return nothing to avoid errors - API call to be fully removed in JPX-597
		? EMPTY_QUERY
		: `
query ${ISSUE_VIEW_INTERACTIVE_QUERY}($issueKey: String!)  {
        ${!fg('remove-issueviewinteractivequery-m4') ? viewIssueQuery(url) : null}
    }

`;

/**
 * @deprecated DO NOT USE ANYMORE
 * See here for details: https://hello.atlassian.net/wiki/spaces/JFP/pages/6034403445/Investigate+Optimise+issueViewInteractiveQuery
 */
export const buildIssueQueryV2 = (url?: URL): string =>
	fg('remove-issueviewinteractivequery-m4') // For now just making it return nothing to avoid errors - API call to be fully removed in JPX-597
		? EMPTY_QUERY
		: `
query ${ISSUE_VIEW_INTERACTIVE_QUERY}($issueKey: String!)  {
        ${!fg('remove-issueviewinteractivequery-m4') ? viewIssueQuery(url, /* includeForgeQuery */ false) : null}
    }
`;
